<section
  #dialogContainer
  class="lm-timer"
  [class.lm-timer--opens]="opensActivity"
  (click)="onCardClick($event)"
  role="region"
  aria-labelledby="timer-overlay-title"
  tabindex="-1">
  <button
    type="button"
    class="lm-icon-btn lm-icon-btn--ghost lm-timer__hide"
    (click)="onHide()"
    aria-label="Hide timer"
    title="Hide timer">
    <svg lucideMinimize2 class="lm-icon" aria-hidden="true"></svg>
  </button>
  <p id="timer-overlay-title" class="lm-timer__activity">
    <a
      *ngIf="activityLinkCommands?.length; else plainActivityName"
      class="lm-timer__activity-link"
      [routerLink]="activityLinkCommands"
      [queryParams]="activityLinkQueryParams">{{ activityName }}</a>
    <ng-template #plainActivityName>{{ activityName }}</ng-template>
    <span *ngIf="slotProgress" class="lm-timer__slot">{{ slotProgress }}</span>
    <ng-container *ngIf="groupLinkLabel && groupLinkCommands?.length">
      <span aria-hidden="true"> · </span>
      <a [routerLink]="groupLinkCommands" [queryParams]="{ timer: 'open' }">in {{ groupLinkLabel }}</a>
    </ng-container>
  </p>
  <p class="lm-timer__label">Elapsed</p>
  <div class="timer-readout">
    <p
      class="lm-timer__time"
      [class.lm-timer__time--paused]="isPaused()"
      [class.lm-timer__time--over]="isOverTime()">
      {{ formatElapsed(elapsedMs()) }}
    </p>
    <p *ngIf="isPaused()" class="timer-state" role="status" aria-live="polite">
      Paused
    </p>
    <p *ngIf="isOverTime() && readoutOverrunMs() > 0" class="timer-state" role="status">
      {{ formatOverrun(readoutOverrunMs()) }}
    </p>
  </div>
  <div *ngIf="autoAdvanceCountdownSec() !== null" class="lm-notice lm-notice--attention" role="status" aria-live="polite">
    <strong>Planned focus time complete.</strong>
    Starting next slot in {{ autoAdvanceCountdownSec() }}s.
    <button type="button" class="lm-btn" (click)="cancelAutoAdvanceCountdown()" [disabled]="submitting">
      Cancel
    </button>
  </div>
  <div *ngIf="showPlannedCompleteBanner() && autoAdvanceCountdownSec() === null" class="lm-notice lm-notice--attention" role="status" aria-live="off">
    <strong>Planned focus time complete.</strong>
    <ng-container *ngIf="overrunMs() > 0">{{ formatOverrun(overrunMs()) }}</ng-container>
  </div>
  <p class="sr-only" aria-live="polite" aria-atomic="true">{{ milestoneAnnouncement() }}</p>

  <div *ngIf="error" class="timer-error">
    <p class="lm-error-text" role="status" aria-live="polite">{{ error }}</p>
    <button type="button" class="lm-btn" (click)="onRefreshDay()" [disabled]="submitting">
      Refresh day
    </button>
  </div>

  <div class="actions">
    <button type="button" class="lm-btn lm-btn--go" (click)="onComplete()" [disabled]="submitting">
      {{ submitting ? 'Saving…' : 'Complete' }}
    </button>
    <button
      *ngIf="!isPaused()"
      type="button"
      class="lm-btn"
      (click)="onPause()"
      [disabled]="submitting"
      aria-label="Pause focus timer">
      {{ submitting ? 'Saving…' : 'Pause' }}
    </button>
    <button
      *ngIf="isPaused()"
      type="button"
      class="lm-btn"
      (click)="onResume()"
      [disabled]="submitting"
      aria-label="Resume focus timer">
      {{ submitting ? 'Saving…' : 'Resume' }}
    </button>
    <button type="button" class="lm-btn" (click)="onSkip()" [disabled]="submitting">
      {{ submitting ? 'Saving…' : 'Skip' }}
    </button>
  </div>
</section>
